
const digest = 'a71d616b23379baa613ec15a29ba199cc3da4cac1722c9ac844bb293e54c811f';
const classes = {"wrapper":"_wrapper_wtmux_1","header":"_header_wtmux_9","nameWrapper":"_nameWrapper_wtmux_13","hasShift":"_hasShift_wtmux_20","title":"_title_wtmux_29","content":"_content_wtmux_36"};
const css = `._wrapper_wtmux_1 {
  font-family: "Rubik", sans-serif;
  display: flex;
  flex-direction: column;
  padding: 12px;
  cursor: pointer;
  gap: 4px;
}
._wrapper_wtmux_1 ._header_wtmux_9 {
  display: flex;
  align-items: center;
}
._wrapper_wtmux_1 ._header_wtmux_9 ._nameWrapper_wtmux_13 {
  display: flex;
  flex: 1;
  flex-direction: row;
  gap: 10px;
  align-items: center;
}
._wrapper_wtmux_1 ._header_wtmux_9 ._nameWrapper_wtmux_13 ._hasShift_wtmux_20 {
  font-family: Rubik, sans-serif;
  font-size: 10px;
  font-weight: 500;
  padding: 3px 7px;
  border-radius: 4px;
  background-color: #619612;
  color: #fff;
}
._wrapper_wtmux_1 ._header_wtmux_9 ._title_wtmux_29 {
  font-weight: 500;
  color: #1665d8;
  text-decoration: underline;
  font-size: 14px;
  flex: 1;
}
._wrapper_wtmux_1 ._content_wtmux_36 {
  color: #000000;
  font-weight: 400;
  font-size: 12px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  